import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import numeral from 'numeral';
import { stringToBoolean } from 'deep-cuts';
import { getAllAccounts, deleteAccount } from '../redux/modules/account';
import { getBank } from '../redux/modules/bank';
import { getaddress } from '../redux/modules/address';
import { PAYMENT_FORM } from '../redux/modules/form';
import { createUserPayment } from '../redux/modules/userPayment';
import { notifSend } from '../redux/modules/notifs';
import { infoSend } from '../redux/modules/info';
import PaymentForm from '../components/PaymentForm';
import { MESSAGES } from '../strings';
import { transformSelectorElementsToValues } from '../utils/form';
import { readableList } from '../utils/string';
import * as storage from '../utils/storage';

const paymentFormValueSelector = formValueSelector(PAYMENT_FORM);

export class Payment extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    user: PropTypes.object,
    selectedSavedAccount: PropTypes.string,
    isProcessingExternalPayment: PropTypes.bool,
    isNewAccount: PropTypes.bool,
    error: PropTypes.string,
    bankDetails: PropTypes.object,
    getAllAccounts: PropTypes.func.isRequired,
    getBank: PropTypes.func.isRequired,
    getaddress: PropTypes.func.isRequired,
    createUserPayment: PropTypes.func.isRequired,
    deleteAccount: PropTypes.func.isRequired,
    infoSend: PropTypes.func.isRequired,
    notifSend: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    selectedSavedAccount: null,
    isNewAccount: false,
    isProcessingExternalPayment: false,
    loading: false,
    error: null,
    bankDetails: null,
    user: null,
  };

  componentDidMount = () => {
    const { user, getAllAccounts } = this.props;
    if (!_.isNil(user)) {
      getAllAccounts();
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const { error, notifSend } = nextProps;
    if (error) {
      notifSend({
        message: error,
        kind: 'danger',
      });
    }
  };

  payment = (data) => {
    const { createUserPayment } = this.props;
    const paymentQuery = storage.get('paymentQuery');
    const nsfComment = _.get(paymentQuery, 'nsfComment');
    if (stringToBoolean(nsfComment)) {
      data.memo = `$40 NSF fee applied. ${data.memo || ''}`;
    }
    return createUserPayment(transformSelectorElementsToValues(data)).then(this.successPayment);
  };

  removeAccount = () => {
    const { selectedSavedAccount, deleteAccount } = this.props;
    return deleteAccount(selectedSavedAccount);
  };

  successPayment = (data) => {
    const { router, error } = this.props;
    if (!error) {
      router.push(`/operationComplete?message=${MESSAGES.PAYMENT_SUBMITTED}`);
    }
    return data;
  };

  handlePaymentContractInfo = ({ payment, contractNumbers, amounts, nsfComment }) => {
    if (payment) {
      const { infoSend } = this.props;
      const contractsAndAmounts = _.chain(contractNumbers)
        .map(
          (contractNumber, index) =>
            `${contractNumber}: ${numeral(_.get(amounts, index)).format('$0,0.00')}`,
        )
        .value();
      const message = _.chain([
        `Payment ${numeral(payment).format('$0,0.00')}${!contractsAndAmounts ? '.' : ''}`,
        contractsAndAmounts && `for contract numbers: ${readableList(contractsAndAmounts)}.`,
        nsfComment && '$40 NSF fee applied.',
      ])
        .filter()
        .join(' ')
        .value();

      infoSend(message, false);
    }
  };

  handleNewAccount = () => {
    const { router } = this.props;
    router.push('/saveAccount');
  };

  handleChangeRoutingNumber = _.debounce((event) => {
    const routingNumber = _.get(event, 'target.value');
    const { getBank } = this.props;
    if (_.size(routingNumber) === 9) {
      getBank(routingNumber);
    }
  }, 500);
  handleZipCodeChange = _.debounce((event) => {
    const zipCode = _.get(event, 'target.value');
    console.log('number of numbers', zipCode);
    const { getaddress } = this.props;
    if (_.size(zipCode) === 5) {
      getaddress(zipCode);
    }
  }, 500);

  render() {
    const {
      bankDetails,
      loading,
      isProcessingExternalPayment,
      isNewAccount,
      user,
      selectedSavedAccount,
    } = this.props;

    return (
      <div className="container">
        <Helmet title="Payment" />
        <PaymentForm
          bankDetails={bankDetails}
          onSubmit={this.payment}
          isNewAccount={isNewAccount}
          onNewAccount={this.handleNewAccount}
          onRemoveAccount={this.removeAccount}
          onNotifyUserOfPayment={this.handlePaymentContractInfo}
          selectedSavedAccount={selectedSavedAccount}
          onChangeRoutingNumber={this.handleChangeRoutingNumber}
          onZipCodeChange={this.handleZipCodeChange}
          user={user}
          disableSubmit={loading}
          disableAmount={isProcessingExternalPayment}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    user: state.auth.user,
    isProcessingExternalPayment: !!state.info.message,
    loading: state.page.loading,
    selectedSavedAccount:
      paymentFormValueSelector(state, 'savedAccount') ||
      _.get(state.auth.user, 'savedAccounts[0].bankName'),
    error: state.userPayment.error,
    bankDetails: state.bank.details,
  }),
  {
    getAllAccounts,
    getBank,
    createUserPayment,
    deleteAccount,
    infoSend,
    getaddress,
    notifSend,
  },
)(Payment);
